/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var BaseCollection = require("collections/BaseCollection");
    var ListItemModel = require("ui/list/js/models/ListItemModel");

    var ListItemsCollection = BaseCollection.extend({
        model: ListItemModel,

        initialize: function(models, options) {
            var comparator = _.has(options, "comparator") ? options.comparator : this._comparator;
            if (comparator === true) {
                this.setComparator(this._comparator);
            }
            else if (comparator !== false) {
                this.setComparator(comparator);
            }
        },
        _comparator: function(item) {
            var comparators = [];
            if (this.groupsOrder && item.get("group")) {
                var groupIndex = _.indexOf(this.groupsOrder, item.get("group"));
                comparators.push(groupIndex);
            }
            comparators.push(item.get("value").toString().toLowerCase());
            return comparators;
        },
        getComparator: function() {
            return this.comparator;
        },
        setComparator: function(comparator) {
            this.comparator = comparator;
        },
        setGroupsOrder: function(groupsOrder) {
            this.groupsOrder = groupsOrder;
        }
    });

    ListItemsCollection.Model = ListItemModel;

    return ListItemsCollection;

});
